import { dyslexicBlacklist } from 'lightning-common/lib/configuration';
import { Routes, getUrl } from 'lightning-common/lib/routing';
import { useCookies } from 'react-cookie';

const oneYearInMilliseconds = 365 * 24 * 60 * 60 * 1000;

interface UserPreferences {
    dyslexic?: boolean;
    languageSelection?: string;
}

export const useLanguageSettings = (isAuthenticated: boolean) => {
    const [, setCookies, removeCookies] = useCookies([
        'dyslexic-setting',
        'language-selection',
    ]);

    const setCookieAndRefresh = (localeCode: string) => {
        removeCookies('language-selection');

        let domain = window.location.hostname || 'overdrive.com';
        domain = '.' + domain.split('.').splice(-2).join('.'); // grab everything after second-to-last period

        setCookies('language-selection', localeCode, {
            httpOnly: false,
            expires: new Date(Date.now() + oneYearInMilliseconds),
            domain,
            path: '/',
            sameSite: 'lax',
            secure: true,
        });

        // Prevents refresh loop when errors occur or cannot retrieve auth
        if (window.OverDrive?.authType !== 'error') {
            window.location.reload();
        }
    };

    const updateLanguageSettings = (localeCode: string) => {
        const updatedPreferences: UserPreferences = {
            languageSelection: localeCode,
        };

        // If the language does not support dyslexic font, remove the dyslexic cookie
        if ((dyslexicBlacklist as any)[localeCode]) {
            removeCookies('dyslexic-setting');
            updatedPreferences.dyslexic = false;
        }

        if (isAuthenticated) {
            // TODO: Test with IE
            fetch(getUrl(Routes.preferences), {
                method: 'PATCH',
                body: JSON.stringify(updatedPreferences),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }).then(() => {
                setCookieAndRefresh(localeCode);
            });
        } else {
            setCookieAndRefresh(localeCode);
        }
    };

    return updateLanguageSettings;
};
